import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import { FaRupeeSign, FaRegCalendar } from "react-icons/fa";


const LaundryBill = ({ initialValues = {}, setIsAddDuesModal, setSelectedOption }) => {
  const formik = useFormik({
    initialValues: {
      amount: initialValues.amount || "",
      startdate: initialValues.startdate ? moment(initialValues.startdate).format("YYYY-MM-DD") : "",
      enddate: initialValues.enddate ? moment(initialValues.enddate).format("YYYY-MM-DD") : "",
      dueDate: initialValues.dueDate ? moment(initialValues.dueDate).format("YYYY-MM-DD") : "",
      description: initialValues.description || "",
    },
    validationSchema: Yup.object({
      amount: Yup.number(),
      startdate: Yup.date(),
      enddate: Yup.date(),
      dueDate: Yup.date(),
      description: Yup.string(),
    }),
    onSubmit: (values) => {
      if (!values.amount) {
        toast.error("Please enter amount");
        return;
      }
      if (!values.startdate) {
        toast.error("Please select start date");
        return;
      }
      if (!values.enddate) {
        toast.error("Please select End date");
        return;
      }
      if (!values.dueDate) {
        toast.error("Please select Due date");
        return;
      }
      if (!values.description) {
        toast.error("Please enter description");
        return;
      }
      const Payload = {
        amount: Number(values.amount),
        startdate: values.startdate,
        enddate: values.enddate,
        dueDate: values.dueDate,
        description: values.description,
      };
      console.log("Payload Data :", Payload);
      setIsAddDuesModal(false);
      toast.success("Dues Added Successfully");
    },
  });

  return (
    <Container>
      <form className="px-1  flex flex-col gap-4" onSubmit={formik.handleSubmit}>
        <ScrollableContent className="!max-h-[calc(100vh-140px)]">
          <Wrapper>
            {/* Amount */}
            <InputGroup>
              <Label htmlFor="amount">Amount *</Label>
              <FieldWrappers>
                <RupeeIcon />
                <input
                  type="text"
                  id="amount"
                  placeholder="Enter Amount"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...formik.getFieldProps("amount")}
                  onKeyDown={(e) => {
                    if (!/^\d$/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault();
                    }
                  }}
                  className="pl-6"
                />
              </FieldWrappers>
            </InputGroup>

            {/* Date and Due Date */}
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="startdate">Start Date *</Label>
                <FieldWrappers>
                  <CalendarIcon />
                  <input
                    type="date"
                    id="startdate"
                    {...formik.getFieldProps("startdate")}
                    className="pl-6"
                  />
                </FieldWrappers>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="enddate">End Date *</Label>
                <FieldWrappers>
                  <CalendarIcon />
                  <input
                    type="date"
                    id="enddate"
                    {...formik.getFieldProps("enddate")}
                    className="pl-6"
                  />
                </FieldWrappers>
              </InputGroup>
            </CombineInputGroup>
            <InputGroup>
                <Label htmlFor="dueDate">Due Date *</Label>
                <FieldWrappers>
                  <CalendarIcon />
                  <input
                    type="date"
                    id="dueDate"
                    {...formik.getFieldProps("dueDate")}
                    className="pl-6"
                  />
                </FieldWrappers>
              </InputGroup>

            {/* Description */}
            <InputGroup>
              <Label htmlFor="description">Description</Label>
              <FieldWrapper>
                <Textarea
                  id="description"
                  placeholder="Enter Description"
                  {...formik.getFieldProps("description")}
                  rows={4}
                />
              </FieldWrapper>
            </InputGroup>
          </Wrapper>
        </ScrollableContent>

        {/* Action Buttons */}
        <ActionSection>
          <SideCancelBtn type="button" onClick={() => setSelectedOption(null)}>
            Back
          </SideCancelBtn>
          <SubmitBtn type="submit">Add Dues</SubmitBtn>
        </ActionSection>
      </form>
    </Container>
  );
};

const FieldWrapper = tw.div`w-full`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
// const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Textarea = tw.textarea`min-h-30 border rounded pl-2 py-2 w-full h-30 resize-y  break-words overflow-hidden`;
const CombineInputGroup = tw.div`w-full flex md:flex-row flex-col space-x-4 items-end`;
const InputGroup = tw.div`w-full flex flex-col space-y-1.5 mt-2 md:mt-0`;
const FieldWrappers = tw.div`pl-2 relative rounded-md w-full flex items-center border border-gray-300 h-10`;
const Label = tw.label`text-sm text-gray-500 font-normal`;
const SubmitBtn = tw.button`text-sm w-32 md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed md:text-base bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;
const SideCancelBtn = tw.button`text-sm w-32 md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed md:text-base text-gray-600`;
const Wrapper = tw.div`grid gap-4 mt-4 overflow-y-auto`;
const ScrollableContent = tw.div`flex-grow overflow-y-auto max-h-[calc(100vh-200px)] custom-scrollbar mb-10`;
const ActionSection = tw.div`px-4 py-2 bg-white flex justify-between border-t border-gray-200 absolute bottom-0 left-0 w-full`;
const RupeeIcon = tw(FaRupeeSign)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`; const CalendarIcon = tw(FaRegCalendar)`
absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`;
export default LaundryBill;
